import React from 'react';
import { Typography } from '@mui/material';

const CustomClickableLabel = ({onClick, children }) => {
    const textColor = '#604CC3'; // Define your text color here or pass it as a prop

    return (
        <div > {/* Add onClick and cursor style */}
            <Typography onClick={onClick} style={{ cursor: 'pointer', color: textColor, fontSize: 14}}>
                {children}
            </Typography>
        </div>
    );
}

export default CustomClickableLabel